export enum AdditionalInfoSeverity {
  DEFAULT = 'default',
  INFO = 'info',
}
